module.exports = __webpack_public_path__ + "img/brasil.0fe34c73.jpg";